import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="drag-drop"
export default class extends Controller {
  static values = { fileType: String };
  static targets = [
    "input",
    "icon",
    "inputContainer",
    "submitContainer",
    "dragZone",
  ];

  connect() {
    this.dragZone = this.hasDragZoneTarget ? this.dragZoneTarget : this.element;
    this.dragZone.addEventListener("dragover", this.dragOver.bind(this));
    this.dragZone.addEventListener("dragleave", this.dragLeave.bind(this));
    this.dragZone.addEventListener("drop", this.drop.bind(this));
  }

  dragOver(event) {
    event.preventDefault();
    this.#successFixState();
  }

  dragLeave(event) {
    event.preventDefault();
    this.iconTarget.classList.remove("bg-white");
    this.iconTarget.classList.add("bg-neutral");
    this.dragZone.removeAttribute("data-state");
  }

  drop(event) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    this[`${this.fileTypeValue}Drop`](files);
  }

  audioDrop(files) {
    if (files.length === 1) {
      this.inputTarget.files = files;
      this.submit();
    } else {
      this.#displayError();
    }
  }

  textDrop(files) {
    this.inputTarget.files = files;
    this.verifyFiles();
  }

  submit() {
    const type = this.#findType(this.inputTarget);
    if (this.#audioAuthorizedFormats().includes(type)) {
      this.#displaySuccess();
      this.element.requestSubmit();
    } else {
      this.#displayError();
    }
  }

  verifyFiles() {
    const types = this.#findTypes(this.inputTarget);
    const isInvalid = types.some(
      (type) => !this.#textAuthorizedFormats().includes(type),
    );
    if (isInvalid) {
      this.#displayError();
    } else {
      this.#successFixState();
    }
  }

  #successFixState() {
    this.iconTarget.classList.add("bg-white");
    this.iconTarget.classList.remove("bg-neutral");
    this.dragZone.dataset.state = "dragging";
  }

  #displaySuccess() {
    this.inputContainerTarget.classList.add("hidden");
    this.submitContainerTarget.classList.remove("hidden");
    this.dragZone.dataset.state = "success";
  }

  #displayError() {
    this.dragZone.dataset.state = "error";
  }

  #audioAuthorizedFormats() {
    return [
      "audio/mpeg",
      "audio/aac",
      "audio/flac",
      "video/mp4",
      "audio/ogg",
      "audio/wav",
      "video/webm",
      "audio/x-m4a",
    ];
  }

  #textAuthorizedFormats() {
    return [
      "application/pdf",
      "text/plain",
      "text/rtf",
      "application/vnd.oasis.opendocument.text",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
  }

  #findType(target) {
    return target.files[0].type;
  }

  #findTypes(target) {
    return Array.from(target.files).map((file) => file.type);
  }
}
